import {Row, Col} from 'antd';
import {useFormikContext} from 'formik';
import {Input} from 'formik-antd';
import {useIntl} from 'react-intl';
import FormItem from 'src/shared/components/form-item';
import {
  getLocaleValue,
  handleChangeLocales,
} from 'src/shared/functions/change-locales';

interface IOptionModalLanguageProps {
  code: string;
  index: number;
}

const OptionModalLanguage = (props: IOptionModalLanguageProps) => {
  const {code, index} = props;

  const {messages} = useIntl();

  const {setFieldValue, values} = useFormikContext<any>();

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <FormItem
            name='value'
            label={messages['common.description'].toString()}
            fieldCommponent={
              <Input.TextArea
                name={'value'}
                value={getLocaleValue(values?.locales, code, 'value')}
                onChange={(value) =>
                  handleChangeLocales(
                    values?.locales,
                    setFieldValue,
                    `locales`,
                    code,
                    'value',
                    value.target.value,
                  )
                }
                rows={4}
              />
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default OptionModalLanguage;
